import t from "./exponent.js";
function e(a, o) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(t(o) / 3))) * 3 - t(Math.abs(a)));
}
export {
  e as default
};
